import { WordBankCollection } from './index';
import { jamaicanWords } from './jamaicanWords';
import { techJargon } from './techJargon';
import { bajanWords } from './bajanWords';

export const wordBanks: WordBankCollection = {
  [jamaicanWords.id]: jamaicanWords,
  [techJargon.id]: techJargon,
  [bajanWords.id]: bajanWords,
};

export const getWordBankList = () => {
  return Object.values(wordBanks).map(bank => ({
    id: bank.id,
    name: bank.name,
    description: bank.description,
    wordCount: bank.words.length,
    categories: bank.categories,
  }));
};

export const getWordBank = (id: string) => {
  return wordBanks[id];
};

// Get a list of all available categories across all word banks
export const getAllCategories = () => {
  const categories = new Set<string>();
  Object.values(wordBanks).forEach(bank => {
    bank.categories.forEach(category => categories.add(category));
  });
  return Array.from(categories).sort();
};

// Get a list of all difficulties
export const getDifficulties = () => ['easy', 'medium', 'hard'] as const; 